import React from 'react';

function PageNotFound({ IP }) {
    return (
        <div>
            <h2 className='text-center mt-4'>Page not found</h2>
        </div>
    );
}

export default PageNotFound;